<script>
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';
export default {
  components: {
    Thumbnail,
  },
  props: {
    option: {
      type: Object,
      default: () => {},
    },
    variant: {
      type: String,
      default: 'default',
    },
    // Item que ja esta aplicado na conversa. A lista de etiquetas mostra TODAS
    // as da conta, entao sem essa marca nao havia como saber quais ja estavam
    // na conversa -- so clicando e vendo o aviso.
    selected: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div
    class="menu text-body"
    role="button"
    @click.stop="$emit('click')"
  >
    <fluent-icon
      v-if="variant === 'icon' && option.icon"
      :icon="option.icon"
      size="14"
      class="menu-icon"
    />
    <span
      v-if="variant === 'label' && option.color"
      class="label-pill"
      :style="{ backgroundColor: option.color }"
    />
    <Thumbnail
      v-if="variant === 'agent'"
      :username="option.label"
      :src="option.thumbnail"
      :status="option.status"
      size="20px"
      class="agent-thumbnail"
    />
    <p
      class="menu-label overflow-hidden whitespace-nowrap text-ellipsis"
      :class="{ 'font-semibold': selected }"
      :title="option.label"
    >
      {{ option.label }}
    </p>
    <fluent-icon
      v-if="selected"
      icon="checkmark"
      size="14"
      class="menu-check"
    />
  </div>
</template>

<style scoped lang="scss">
.menu {
  width: calc(var(--space-mega) * 2);
  @apply flex items-center flex-nowrap p-1 rounded-sm overflow-hidden cursor-pointer;

  // `min-w-0` no lugar de `flex-shrink-0`: como item de flex o `<p>` nunca
  // encolhia abaixo do conteudo, entao o `text-ellipsis` que ele ja tinha nunca
  // chegava a agir -- nome longo era cortado a seco pelo `overflow-hidden` do
  // menu, sem reticencia. E, agora, empurraria o visto para fora.
  .menu-label {
    @apply my-0 mx-2 text-xs min-w-0;
  }

  // Encostado na borda direita, longe da cor da etiqueta, para os dois sinais
  // nao competirem. Herda `currentColor`, entao continua legivel sobre o azul
  // do hover.
  .menu-check {
    @apply ltr:ml-auto rtl:mr-auto flex-shrink-0;
  }

  &:hover {
    @apply bg-woot-500 dark:bg-woot-500 text-white dark:text-slate-50;
  }
}

.agent-thumbnail {
  margin-top: 0 !important;
}

.label-pill {
  @apply w-4 h-4 rounded-full border border-line-faint border-solid flex-shrink-0;
}
</style>
